<div id="invite" [ngClass]="type">
    <div class="clearfix"></div>
    <div class="title-wrapper">
        <h2 translate>Invitation</h2>
        <a
            tabindex="0"
            (click)="close()"
            (keypress)="close()"
            class="close-modal"
            aria-label="Close Invite form">
            <img src="./assets/img/icons-svg/close-icon.svg" />
        </a>
    </div>

    <form novalidate [formGroup]="inviteForm" (ngSubmit)="sendInvite()">
        <div class="form-wrapper">
            <div class="app-c-form-group">
                <label class="app-c-form--label" for="email" translate>Email</label>
                <input
                    class="app-c-form-control"
                    id="email"
                    tabindex="0"
                    formControlName="email"
                    name="email"
                    type="text"
                    placeholder="Enter the user's email" />
                <img
                    alt="Email validation checkbox"
                    *ngIf="f.email.touched && !f.email.errors"
                    src="./assets/img/icons/check@2x.png"
                    class="float-right check animated fadeInUp" />
                <div class="error-message" *ngIf="f.email.touched && f.email.errors?.required">
                    Please enter a valid email
                </div>
            </div>

            <div class="app-c-form-group" [ngClass]="{ disable: this.inviteType === 'clientInvite' }">
                <label class="app-c-form--label" for="role" translate>Role</label>
                <mat-select
                    class="app-c-form-control"
                    id="role"
                    formControlName="role"
                    (change)="showShareOpt()">
                    <mat-option value="">Please select the role</mat-option>
                    <mat-option *ngFor="let role of roles" [value]="role.value">{{ role.name }}</mat-option>
                </mat-select>
                <div class="error-message" *ngIf="f.role.touched && f.role.errors?.required">
                    Please select a role
                </div>
            </div>

            <div class="sharing" *ngIf="showShare">
                <label class="app-c-checkbox">
                    <input type="checkbox" name="share" formControlName="share" />
                    <span translate>invite.share</span>
                </label>
            </div>

            <div class="app-c-form-group">
                <label class="app-c-form--label" for="message" translate>
                    invite.msgTitle
                    <span>Max 200 words</span>
                </label>
                <textarea
                    class="app-c-form-control"
                    id="message"
                    tabindex="0"
                    formControlName="message"
                    name="message"
                    [placeholder]="'invite.placeholder' | translate"></textarea>
            </div>
        </div>
        <div class="fixed-footer">
            <a
                tabindex="0"
                (click)="sendInvite()"
                (keypress)="sendInvite()"
                class="btn btn-primary"
                translate>invite.send</a>
        </div>
    </form>
</div>
